<template>
  <div>
     <Header
      title="教师评学"
      route="/new/Home_10013"
    ></Header>
    <div class="teacher">  

      <div class="jspxTop">
        <div id="cphdmc"></div>
        <div>学年学期：<span id="xnxqmc"></span></div>
        <!-- <p>评学教师：{{ cphdmc }}</p>
        <p>评学班级：{{ xnxqmc }} </p> -->
      </div>


      <div
        v-for="(item, index) in jspxkcList"
        :key="index"
        @click="goEvaluate(item.pj25id)"
      >
        <div class="jspxItem">
          <div class="jspxContent">
            <h4 class="jspxTitle">
              {{ item.kcmc }} （  {{ item.kch }}）
            </h4>
            <div class="jspxDesc">
              <p>评学教师：{{ item.xm }}</p>
              <p>评学班级：{{ item.cp_bj }} </p>
              <p>上课周次：{{ item.kkzc }} </p>
              <p>是否提交：{{ item.issubmit2 }} </p>
            </div>
          </div>
          <div class="jspxImg">
            <img src="" alt="">
            <div class="">评价</div>
          </div>
        </div>
        
      </div> 
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";
import {Api} from '../../../utils/axios'
  export default {
    data(){
      return{
        evaluateList:[],
        jspxkcList: [],
        isShow:true,
        isShow1:true,
        isShow3:true,
        schoolCode: sessionStorage.getItem("schoolCode"),
        alertType:this.$route.query.alertType,
        cphdmc:this.$route.query.cphdmc,
        xnxqmc:this.$route.query.xnxqmc
      }
    },
    methods:{ 
      goEvaluate(pj25id){ 
          this.$router.push({
              path:'/jspx/jspxkc_edit',
              query:{
                  'pj2201id':this.$route.query.pj2201id,
                  'pj25id':pj25id
              }
          }) 
      }, 
      async getjspxkcList(){
        const params = {
          pj2201id: this.$route.query.pj2201id 
        }
        const res = await Api.getJspxkcApi_10013(params)
        if(res.errorCode == 'fail'){
          this.$toast.fail(res.errorMessage)
        }else{
          this.jspxkcList = res.data
        }
      }
    },
    created(){
      this.getjspxkcList(); 
      
    },
    mounted(){
      var cphdmcSpan = $("#cphdmc")
      console.log(cphdmcSpan)
      console.log(this.cphdmc)
      cphdmcSpan.html(this.cphdmc)
      var xnxqmcSpan = $("#xnxqmc")
      // console.log(itemNameSpan.html)
      xnxqmcSpan.html(this.xnxqmc)
    }

  }
</script>


<style lang="less" scoped>
  .teacher{
    .jspxTop{
      margin: 12px 15px;
      background-color: #2b67e1;
      box-shadow: 0 2px 10px 0 #2b67e14d;
      border-radius: 8px;
      height: 46px;
      padding: 15px;
      color: #fff;
      #cphdmc{
        font-weight: 500;
        font-size: 16px;
        height: 22px;
        padding-bottom: 4px;
      }
      #xnxqmc{
        font-weight: 400;
        font-size: 14px;
        height: 20px;
      }
    }
    .jspxItem{
      margin: 12px 15px;
      width: 345px;
      height: 141px;
      background-color: #f8f8f8;
      border-radius: 8px;
      .jspxContent{
        float: left; 
        padding: 14px 15px;
        .jspxTitle{
          font-weight: 600;
          font-size: 16px;
          color: #333;
          height: 22px;
          padding-bottom: 5px;
        }
        .jspxDesc{
          font-size: 14px;
          font-weight: 400;
          color: #999;
          height: 22px;
          // padding-bottom: 12px;
        }
      }
      .jspxImg{
        float:right;
        border-left: 1px solid #e5e5e5;
        // width: 1px;
        width: 75.5px;
        height: 93px;
        margin-top: 24px;
        // line-height: 93px;
        text-align: center;
        font-size: 14px;
        font-weight: 400;
        color: #2b67E1;
      }
    }
  }
  .grey-contain button{background-color: @attendance-background-color-1;padding: 11px 19px;border-radius: 3px;color: @attendance-color-3;min-height: 40px}
  .delay-btn{position: absolute;bottom: 20px;width: 100%;text-align: center;}
  .delay-btn button{background-color: @attendance-background-color-7;color: @attendance-background-color-1;padding: 11px 0;width: 90%;border-radius: 3px;}
  .r_box{
        width: 24%;
        height: 42px;
        float: right;
        background: url(../../../assets/images/bg_icon.png) center center no-repeat;
        background-size: 100%;
        /* margin: 20px 20px 0 0; */
        text-align: center;
    }
    .contain-txt{overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}
    .r_box span{
      display: block
    }
    .r_box .number{
        color: @attendance-color-3;
        font-size: 18px;
        margin-top: 3px
    }
    .r_box .grade{
        color: @attendance-color-3;
        font-size: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/teacher/jspx/jspxkc_list.vue